import styled from 'styled-components';
import { black } from 'constants/colors';

export const NoRecommendationsStylized = styled.div`
  padding: 2rem 0;

  > .content {
    width: 80rem;
    max-width: 90%;
    margin: 0 auto;
    text-align: center;
    position: relative;
    .bg_icon {

    }

    .img_icon {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 5rem;
    }

    .title {
      margin: 2rem;
      color: ${black};
      font-size: 3.2rem;
    }

    .description {
      color: ${black};
      font-size: 1.7rem;
      margin-bottom: 2rem;
    }
  }

  .ongoing_title {
    color: ${black};
    font-size: 1.7rem;
    margin-top: 4rem;
    margin: 4rem 2rem 2rem;
  }

  .simple_carousel {
    padding-left: 2rem;
    margin-bottom: 4rem;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/NoRecommendations/components/styles.js